/**
 * PickUpActionType - Action permettant au joueur de ramasser un objet
 * Identique à Flutter PickUpActionType
 */

import {ActionType} from '../../types/ActionType';
import {GameState} from '../../../models/GameState';
import {PlayerStep} from '../../../models/PlayerStep';
import {PlayerNotification} from '../../../models/PlayerNotification';
import {GameDataAttribute} from '../../../models/GameDataAttribute';

export class PickUpActionType implements ActionType {
  typeName = 'pick_up';

  async execute(
    gameState: GameState,
    currentStep: PlayerStep,
    params?: {[key: string]: any},
  ): Promise<PlayerNotification[]> {
    const objectId = params?.id;
    if (!objectId) {
      throw new Error('PickUpActionType: missing id parameter');
    }

    // Chercher l'objet dans step.objects
    const object = currentStep.objects?.find((obj) => obj.id === objectId);
    if (!object) {
      throw new Error(`PickUpActionType: object with id ${objectId} not found in step.objects`);
    }

    // Vérifier si l'objet n'est pas déjà dans l'inventaire
    const existingObject = gameState.data.objects?.find(
      (obj) => obj.attributeId === objectId && obj.dropped === 0,
    );
    if (existingObject) {
      throw new Error(`PickUpActionType: object ${objectId} is already in inventory`);
    }

    // Ajouter l'objet à l'inventaire
    const newObject: GameDataAttribute = {
      attributeId: objectId,
      value: object.value || '',
      dropped: 0, // 0 = non lâché
    };

    const updatedObjects = [...(gameState.data.objects || []), newObject];
    gameState.data.objects = updatedObjects;

    // Créer une notification
    const notification: PlayerNotification = {
      title: `${object.name} ramassé !`,
      description: `Vous avez ramassé ${object.name}.`,
      isCheat: false,
    };

    console.log(`[PickUpActionType] Picked up object: ${objectId} (${object.name})`);
    return [notification];
  }
}
